<template>
  <div class="shop">
    <div class="top">
      <el-date-picker
        v-model="start_time"
        type="date"
        style="width:136px;margin-right:10px;"
        value-format="yyyy-MM-dd"
        size="mini"
        placeholder="查询日期"
      >
      </el-date-picker>
      <el-button class="search" size="small" type="primary" @click="searchList"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column
        label="今日平台总发出红包"
        prop="issued_today"
      ></el-table-column>
      <el-table-column
        label="今日用户总使用红包"
        prop="data_reduce"
      ></el-table-column>
      <el-table-column
        label="累计平台发出红包"
        prop="count_num"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { redpacketStatistics } from '@/api/redpacket'
export default {
  components: {},
  data() {
    return {
      tableData: [],
      labelPosition: 'right',
      start_time: '',
      total: 0
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    //获取列表数据
    async getList() {
      let start_time = this.start_time
      let url = `start_time=${start_time}`
      let res = await redpacketStatistics(url)
      console.log(res)
      if (res.code === 10000) {
        this.tableData.push(res.data)
      } else {
        this.$message.error(res.message)
      }
    },

    //搜索
    searchList() {
      this.getList()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .top {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
